import React, { Component } from 'react';
export function ContentBreakdown() {
  return <section className="py-[30px] px-0" data-id="element-77">
      <div className="container max-w-[1000px] mx-auto px-[15px]" data-id="element-78">
        <h2 className="text-[24px] text-center mb-[20px] font-[700] text-[#111827] font-['Montserrat']" data-id="element-79">
          📦 Lo que recibís hoy:
        </h2>
        <div className="flex overflow-x-auto gap-[20px] p-[20px] snap-x snap-mandatory" data-id="element-80">
          <div className="bg-white rounded-[8px] overflow-hidden shadow-[0_4px_10px_rgba(0,0,0,0.05)] transition-all duration-400 border border-[#eee] flex-none w-[90%] snap-center hover:transform hover:-translate-y-[5px] hover:shadow-[0_10px_20px_rgba(0,0,0,0.08)]" data-id="element-81">
            <img src="https://app.heylloyd.io/public/files/openrouter-generated-image-1770579016155.png" alt="Guía PDF" className="w-full h-auto" data-id="element-82" />
            <div className="p-[15px]" data-id="element-83">
              <span className="bg-[#8B4513] text-white px-[12px] py-[3px] rounded-[50px] text-[12px] font-bold" data-id="element-84">
                Componente 1:
              </span>
              <h3 className="text-[18px] my-[8px] font-[700] text-[#111827] font-['Montserrat']" data-id="element-85">
                <strong data-id="element-86">Guía PDF Premium – Método BÍBLICO™</strong>
              </h3>
              <p data-id="element-87">El sistema completo, explicado claro y visual.</p>
            </div>
          </div>

          <div className="bg-white rounded-[8px] overflow-hidden shadow-[0_4px_10px_rgba(0,0,0,0.05)] transition-all duration-400 border border-[#eee] flex-none w-[90%] snap-center hover:transform hover:-translate-y-[5px] hover:shadow-[0_10px_20px_rgba(0,0,0,0.08)]" data-id="element-88">
            <img src="https://app.heylloyd.io/public/files/openrouter-generated-image-1770582856647.png" alt="Recetas base" className="w-full h-auto" data-id="element-89" />
            <div className="p-[15px]" data-id="element-90">
              <span className="bg-[#8B4513] text-white px-[12px] py-[3px] rounded-[50px] text-[12px] font-bold" data-id="element-91">
                Componente 2:
              </span>
              <h3 className="text-[18px] my-[8px] font-[700] text-[#111827] font-['Montserrat']" data-id="element-92">
                <strong data-id="element-93">Recetas base por método</strong>
              </h3>
              <p data-id="element-94">Para empezar bien desde la primera taza.</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}